<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <v-row>
            <v-col class="d-flex align-center">
              <img
                width="50px"
                class="mr-2 rounded-circle"
                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/itowokashi.webp"
              >
              ラッシュデュエルラボ カード管理 ver1.51
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" dark @click="editItem()">
              <v-icon>mdi-new-box</v-icon>カード新規追加
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
    </div>

    <v-card class="ma-6 pa-4" min-height="800">
      <v-row class="pl-8">
        <v-col cols="8">
          <v-radio-group v-model="search" :custom-filter="customFilter" row>
            <v-radio
              v-for="(item, index) in c_limit_category_sort_array"
              :key="index"
              :label="index"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="4">
          <v-radio-group v-model="search" :custom-filter="customFilter" row>
            <v-radio
              v-for="(item, index) in c_legend_sort_array"
              :key="index"
              :label="index"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
        <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
      </v-overlay>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        clearable
        @focus="searchTextFieldFocus"
      ></v-text-field>

      <v-data-iterator
        :headers="headers"
        :items="list"
        :search="search"
        :custom-filter="customFilter"
        :items-per-page="200"
        :footer-props="{ itemsPerPageOptions: [200, 500, 700] }"
      >
        <template v-slot:default="props">
          <ul class="deck_list">
            <li v-for="item in props.items" :key="item.title">
              <SimpleCardDisp
                type="card"
                :item="item"
                v-on:editItem="editItem"
                v-on:copyToClipboard="copyToClipboard"
              />
            </li>
          </ul>
        </template>
      </v-data-iterator>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        scrollable
        persistent
        max-width="1500px"
        @click:outside="showDialog = false"
      >
        <v-card width="900" :disabled="loading">
          <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" width="100%">
              <v-col cols="10">
                <div
                  v-if="target_item.id != ''"
                  v-html="checkUrl(target_item.url, target_item.name)"
                ></div>
                <div v-else>カードを新規追加</div>
              </v-col>
              <v-col cols="2" class="text-right pr-5">
                <v-icon large color="blue darken-1" @click="closeDialog()">mdi-close-thick</v-icon>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row>
                <!-- カードイラスト、ボタン -->
                <v-col cols="2" class="mt-6 text-center">
                  <img
                    v-if="target_item.id != ''"
                    class="card_img"
                    width="200"
                    :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/'+target_item.id+'.webp'"
                  >
                  <img
                    v-else
                    class="card_img"
                    width="200"
                    src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/img/all_cards/no_image.webp"
                  >
                  <div class="mt-2">
                    <!-- <div
                      class="button_label_img2 white ml-1 mr-1 mt-3"
                      style="border: 2px solid #F44336 !important; color: #F44336 !important; border-radius: 10px;"
                      @click="copyToClipboard(target_item, 'img')"
                    >
                      <span>
                        <v-icon color="red darken-1" size="30">mdi-image-outline</v-icon>画像ありaタグ
                      </span>
                    </div>
                    <div
                      class="button_label_noimg2 white ml-1 mr-1 mt-3"
                      style="border: 2px solid #F44336 !important; background-color: #F44336 !important; color: #fff !important; border-radius: 10px;"
                      @click="copyToClipboard(target_item, '')"
                    >
                      <span>
                        <v-icon color="white" size="30">mdi-image-off</v-icon>画像なしaタグ
                      </span>
                    </div>-->
                    <v-row class="mt-2">
                      <v-col cols="6" class="d-flex align-center justify-center">
                        <a
                          :href="'https://admin.appmedia.jp/duel_links/'+target_item.url"
                          target="_blank"
                          v-if="target_item.url != ''"
                        >
                          <div class="body-2 font-weight-bold">
                            <v-icon color="light-blue darken-4">mdi-eye-arrow-left-outline</v-icon>記事閲覧
                          </div>
                        </a>
                      </v-col>
                      <v-col cols="6" class="d-flex align-center justify-center">
                        <a
                          :href="'https://admin.appmedia.jp/wp-admin/post.php?post='+target_item.url+'&action=edit'"
                          target="_blank"
                          v-if="target_item.url != ''"
                        >
                          <div class="body-2 font-weight-bold">
                            <v-icon color="light-blue darken-4">mdi-note-edit-outline</v-icon>記事編集
                          </div>
                        </a>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="10">
                  <!-- タブ定義 -->
                  <v-row>
                    <v-col cols="7">
                      <v-tabs center-active v-model="tab">
                        <v-tab>基本情報</v-tab>
                        <v-tab>入手方法・リミット</v-tab>
                        <v-tab>評価</v-tab>
                      </v-tabs>
                    </v-col>
                  </v-row>
                  <!-- 基本情報タブ -->
                  <v-tabs-items v-model="tab">
                    <v-tab-item class="card_tab">
                      <v-row width="100%">
                        <v-col>
                          <v-text-field
                            label="カードID"
                            hide-details="auto"
                            :rules="rules"
                            v-model="target_item.id"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-select
                            label="レアリティ"
                            :items="c_rarity_array"
                            v-model="target_item.rarity"
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-text-field label="レベル" hide-details="auto" v-model="target_item.level"></v-text-field>
                        </v-col>
                        <v-col>
                          <v-select
                            label="レジェンド"
                            :items="c_legend_array"
                            v-model="target_item.legend"
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-text-field
                            label="個別記事URL"
                            hide-details="auto"
                            v-model="target_item.url"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-text-field
                            label="カード名"
                            hide-details="auto"
                            :rules="rules"
                            v-model="target_item.name"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            label="カード名(かな)"
                            hide-details="auto"
                            v-model="target_item.name_kana"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row width="100%">
                        <v-col>
                          <v-text-field
                            label="MAXIMUM ATK"
                            hide-details="auto"
                            v-model="target_item.maximum_atk"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field label="ATK" hide-details="auto" v-model="target_item.atk"></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field label="DEF" hide-details="auto" v-model="target_item.def"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-autocomplete
                            v-model="target_item.attr"
                            :items="c_attr_array"
                            label="属性、魔法/罠"
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-autocomplete v-model="target_item.race" :items="races" label="種族"></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-select
                            label="モンスター種別1(通常/効果)"
                            :items="c_monster_type1_array"
                            v-model="target_item.monster_type1"
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-select
                            label="モンスター種別2(フュージョン/マキシマム)"
                            :items="c_monster_type2_array"
                            v-model="target_item.monster_type2"
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-select
                            label="魔法/罠 種別"
                            :items="c_support_type_array"
                            v-model="target_item.support_type"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-textarea
                            :rows="3"
                            class="custom_textarea"
                            auto-grow
                            outlined
                            v-model="target_item.card_text"
                            label="カードテキスト"
                            counter="2000"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- 入手方法タブ -->
                    <v-tab-item class="card_tab">
                      <v-row width="100%">
                        <v-col>
                          <v-radio-group v-model="target_item.limit_data" row>
                            <v-radio label="無制限" value="無制限"></v-radio>
                            <v-radio label="リミット3" value="リミット3"></v-radio>
                            <v-radio label="リミット2" value="リミット2"></v-radio>
                            <v-radio label="リミット1" value="リミット1"></v-radio>
                            <v-radio label="禁止" value="禁止"></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-autocomplete
                            v-model="target_getdata['パック']"
                            :items="get_master['パック']"
                            item-text="name"
                            item-value="id"
                            auto-select-first
                            chips
                            label="収録パック"
                            multiple
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-autocomplete
                            v-model="target_getdata['キャラ']"
                            :items="get_master['キャラ']"
                            item-text="name"
                            item-value="id"
                            auto-select-first
                            chips
                            label="入手できるキャラ等"
                            multiple
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row width="100%">
                        <v-col>
                          <v-autocomplete
                            v-model="target_getdata['イベント']"
                            :items="get_master['イベント']"
                            item-text="name"
                            item-value="id"
                            auto-select-first
                            chips
                            label="入手できるイベント"
                            multiple
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- 評価タブ -->
                    <v-tab-item class="card_tab">
                      <v-row width="100%">
                        <v-col cols="8">
                          <v-textarea
                            :rows="10"
                            class="custom_textarea"
                            auto-grow
                            outlined
                            v-model="target_item.evaluation"
                            ref="textarea1"
                            id="1"
                            @input="textChange('eva1', target_item.evaluation)"
                            label="簡易評価"
                            counter="2000"
                          ></v-textarea>
                          <div class="caption">＊改行をしたい場合はエンターで改行。brタグは不要です</div>
                          <div class="caption">＊記事ではh3タグで「〜のカード評価」が入るので重複しないように注意！</div>
                        </v-col>
                        <v-col cols="4">
                          <HtmlPreview
                            :evaluation="target_preview.eva1"
                            :add_html="'<h3>'+target_item.name+'のカード評価</h3>'"
                          ></HtmlPreview>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col cols="6" class="d-flex align-center pl-8">
                <v-btn class="font-weight-bold" width="100" color="blue" dark @click="saveItem()">
                  <v-icon small color="white">mdi-check-bold</v-icon>更新
                </v-btn>
                <v-btn
                  width="100"
                  class="ml-4 font-weight-bold"
                  color="red"
                  dark
                  @click="delItem()"
                >
                  <v-icon small color="white">mdi-delete</v-icon>削除
                </v-btn>
              </v-col>
              <v-col cols="6" class="d-flex justify-end">
                <v-btn
                  class="pr-5 font-weight-bold"
                  color="blue darken-1"
                  text
                  @click="closeDialog()"
                >閉じる</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
      {{ snackbarText }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

// コンポーネント
import SimpleCardDisp from "./components/SimpleCardDisp.vue";
import HtmlPreview from "./components/HtmlPreview.vue";

// 定数
import { Config } from "./constants/constants.js";

// 共通関数
import { insertHtmlTag } from "./constants/constants.js";
import { delHtmlTag } from "./constants/constants.js";
import { newlinesToBr } from "./constants/constants.js";
import { brToNewlines } from "./constants/constants.js";

export default {
  components: {
    // カード表示(一覧)
    SimpleCardDisp,
    // 評価プレビュー
    HtmlPreview
  },

  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarColor: "info",
      timeout: 2000,

      detail_dialog: false,
      selected_items: [],

      detail_cards_list: [],

      dialog: false,
      confirm_dialog: false,
      overlay: false,

      honban_flg: false,

      showDialog: false,

      loading: false,

      tab: null,

      list: [],
      card_single_data: {},
      // list2: [],
      // list3: {},

      races: [],

      c_limit_category_sort_array: Config.limit_category_sort_array,
      c_legend_sort_array: Config.legend_sort_array,
      c_rarity_array: Config.rarity_array,
      c_monster_type1_array: Config.monster_type1_array,
      c_monster_type2_array: Config.monster_type2_array,
      c_support_type_array: Config.support_type_array,
      c_legend_array: Config.legend_array,
      c_attr_array: Config.attr_array,

      get_master: {},
      get_master_name: {},

      target_item: {},
      card_data_cols: [],

      target_getdata: {},
      target_getdata_txt: "",

      focus_txt: "",
      focus_txt_ref: "",
      target_a_tag: "",

      target_preview: { eva1: "" },

      headers: [],

      rules: [value => !!value || "入力必須"],

      // //検索用パラメータ
      search: "",

      // // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  //---------------------------
  // 読み込み時に実行
  //---------------------------
  created: function() {
    this.loading = true;
    // カード一覧
    this.getCardList();
    // 種族一覧
    this.getRaceList();
    // 入手方法一覧
    this.getGetMaster();
    // カードデータテーブルのカラムを取得
    this.getCardCols();
    this.loading = false;
  },

  methods: {
    customFilter: function(items, search) {
      if (search === null || search == "") {
        return items;
      }
      items = items.filter(function(value) {
        if (
          search == "禁止" ||
          search == "リミット1" ||
          search == "リミット2" ||
          search == "リミット3"
        ) {
          if (value.limit_data == search) {
            return true;
          } else {
            return false;
          }
        } else if (search == "全リミット") {
          if (
            value.limit_data == "禁止" ||
            value.limit_data == "リミット1" ||
            value.limit_data == "リミット2" ||
            value.limit_data == "リミット3"
          ) {
            return true;
          } else {
            return false;
          }
        } else if (search == "LEGEND") {
          if (value.legend == search) {
            return true;
          } else {
            return false;
          }
        } else {
          if (value.name.indexOf(search) != -1) {
            return true;
          } else if (value.name_kana.indexOf(search) != -1) {
            return true;
          } else if (value.name.indexOf(search) != -1) {
            return true;
          } else {
            return false;
          }
        }
      });
      return items;
    },

    searchTextFieldFocus() {
      this.search = "";
    },

    //---------------------------
    // スナックバー
    // わざわざalertで出さなくてもいいかなって時に
    //---------------------------
    showSnackbar(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },

    //---------------------------
    // 全カード取得
    //---------------------------
    getCardList() {
      axios.get(process.env.VUE_APP_RD_CARD_LIST_LIGHT_VER).then(response => {
        const items = [];
        const items2 = [];
        const items3 = {};
        const values = Object.values(response.data);

        values.forEach(value => {
          items.push(value);

          var item = {
            id: Number(value.id),
            name: value.name
          };
          items2.push(item);

          var item2 = {
            name: value.name,
            url: value.url
          };
          items3[value.id] = item2;
        });

        this.list = items;
      });
    },

    //---------------------------
    // 種族取得
    //---------------------------
    getRaceList() {
      axios.get(process.env.VUE_APP_RD_RACE_LIST).then(response => {
        const items = [];
        const values = Object.values(response.data);
        items.push("-");
        values.forEach(value => {
          items.push(value.name);
        });
        this.races = items;
      });
    },

    //---------------------------
    // クリップボードにURL等をコピー
    //---------------------------
    copyToClipboard(item, type) {
      // console.log(item);
      event.stopPropagation();
      var text = "";
      if (type == "img") {
        text =
          "<a href='https://admin.appmedia.jp/duel_links/" +
          item.url +
          "'><img class='aligncenter card_img' src='https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/" +
          item.id +
          ".webp' alt='デュエルリンクス_" +
          item.name +
          "' width='60' height='87' loading='lazy'>" +
          item.name +
          "</a>";
      } else {
        text =
          "《<a href='https://admin.appmedia.jp/duel_links/" +
          item.url +
          "'>" +
          item.name +
          "</a>》";
      }

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);

      var msg = "";
      if (type == "img") {
        msg = "画像付きリンクをコピーしました！";
      } else {
        msg = "画像なしリンクをコピーしました！";
      }

      this.showSnackbar("《" + item.name + "》の" + msg);
    },

    //---------------------------
    // 評価テキスト変更時
    //---------------------------
    textChange(target_key, preview_html) {
      this.target_preview[target_key] = insertHtmlTag(preview_html);
    },

    //---------------------------
    // 入手方法取得
    //---------------------------
    getGetMaster() {
      axios.get(process.env.VUE_APP_RD_GETMASTER_LIST).then(response => {
        const items = {};
        const items2 = {};
        const values = Object.values(response.data);
        var get_type = "";

        values.forEach(value => {
          if (value.type == "ストラク") {
            get_type = "パック";
          } else {
            get_type = value.type;
          }
          if (typeof items[get_type] == "undefined") {
            items[get_type] = [];
          }
          items[get_type].push(value.name);

          if (typeof items2[value.name] === "undefined") {
            items2[value.name] = value.id;
          }
        });
        this.get_master_name = items2;
        this.get_master = items;
      });
    },

    //---------------------------
    // 編集画面
    //---------------------------
    async editItem(item) {
      // 更新＆削除
      if (typeof item != "undefined") {
        // カード1枚分のデータ取得
        axios
          .get(process.env.VUE_APP_RD_CARD_SINGLE, {
            params: { id: item.id }
          })
          .then(response => {
            const values = Object.values(response.data);

            if (typeof values[0] != "undefined") {
              this.card_single_data = values[0];
            } else {
              alert(
                "予期せぬエラーが発生しました。エンジニアまでご連絡ください。\n error:card_data is undefined."
              );
              return;
            }

            // item(取得したカードデータ)をターゲット配列にコピー
            this.target_item = Object.assign({}, this.card_single_data);
            this.target_item.card_text = brToNewlines(
              this.card_single_data.card_text
            );
            this.target_item.limit_data =
              this.card_single_data.limit_data == ""
                ? "無制限"
                : this.card_single_data.limit_data;
            this.target_item.rarity =
              this.card_single_data.rarity == ""
                ? "-"
                : this.card_single_data.rarity;
            this.target_item.legend =
              this.card_single_data.legend == ""
                ? "-"
                : this.card_single_data.legend;
            this.target_item.race =
              this.card_single_data.race == ""
                ? "-"
                : this.card_single_data.race;
            this.target_item.monster_type1 =
              this.card_single_data.monster_type1 == ""
                ? "-"
                : this.card_single_data.monster_type1;
            this.target_item.monster_type2 =
              this.card_single_data.monster_type2 == ""
                ? "-"
                : this.card_single_data.monster_type2;
            this.target_item.support_type =
              this.card_single_data.support_type == ""
                ? "-"
                : this.card_single_data.support_type;

            this.target_preview["eva1"] = this.target_item.evaluation;
            this.target_item.evaluation = delHtmlTag(
              this.target_item.evaluation
            );

            this.target_post_type = "update";
          });

        // 入手方法取得
        this.getDataByCard(item.id);

        // 新規登録
      } else {
        this.card_single_data = {};

        // ターゲット配列を初期化
        this.card_data_cols.forEach(value => {
          this.target_item[value] = "";
        });
        this.target_item.limit_data = "無制限";
        this.target_item.rarity = "-";
        this.target_item.legend = "-";
        this.target_item.race = "-";
        this.target_item.monster_type1 = "-";
        this.target_item.monster_type2 = "-";
        this.target_item.support_type = "-";

        this.target_preview["eva1"] = "";

        this.target_getdata = {};

        this.target_post_type = "insert";
      }

      this.showDialog = true;
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    //---------------------------
    // カードの入手方法取得
    // 編集画面で開いたカードのIDで取得
    //---------------------------
    getDataByCard(target_id) {
      axios
        .get(process.env.VUE_APP_RD_GETDATA_BY_CARD_LIST, {
          params: { id: target_id }
        })
        .then(response => {
          const items = {};
          const values = Object.values(response.data);
          var get_type = "";
          values.forEach(value => {
            if (value.type == "ストラク") {
              get_type = "パック";
            } else {
              get_type = value.type;
            }
            if (typeof items[get_type] === "undefined") {
              items[get_type] = [];
            }
            items[get_type].push(value.name);
          });

          this.target_getdata = items;
        });
    },

    //---------------------------
    // カードデータテーブルのカラム取得
    //---------------------------
    getCardCols() {
      axios.get(process.env.VUE_APP_RD_CARD_COLS).then(response => {
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          items.push(value.cols);
        });

        this.card_data_cols = items;
      });
    },

    //---------------------------
    // aタグ(個別記事に飛ぶ用)
    //---------------------------
    checkUrl(url, txt) {
      if (url == "" || url == null) {
        return "<span>《" + txt + "》を編集中</span>";
      } else {
        return (
          "<span>《<a href='https://admin.appmedia.jp/duel_links/" +
          url +
          "' target='_blank'>" +
          txt +
          "</a>》を編集中</span>"
        );
      }
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      if (this.target_item.id == "" || this.target_item.id == null) {
        alert("カードIDを入力してください");
        return;
      }

      if (this.target_item.name == "" || this.target_item.name == null) {
        alert("カード名を入力してください");
        return;
      }

      var msg = "";
      if (this.target_post_type == "insert") {
        msg = "新規登録";
      } else if (this.target_post_type == "update") {
        msg = "更新";
      } else {
        alert("エラーが発生しました。post_typeが空です。");
        return;
      }

      // 入手方法をテキストに
      // target_getdataには名前が配列で格納されるので、あらかじめ用意しておいた
      // 名前をキーにしたID配列(get_master_name)からIDを取得する
      // めっちゃごちゃごちゃしてんな！
      this.target_getdata_txt = "";
      for (var value in this.target_getdata) {
        for (var val in this.target_getdata[value]) {
          const n_key = this.target_getdata[value][val];
          if (this.target_getdata_txt != "") {
            this.target_getdata_txt += ",";
          }

          this.target_getdata_txt += this.get_master_name[n_key];
        }
      }

      if (
        !window.confirm(
          "《" +
            this.target_item.name +
            "》を" +
            msg +
            "します。よろしいですか？"
        )
      ) {
        return;
      }

      this.loading = true;

      this.target_item.limit_data =
        this.target_item.limit_data == "無制限"
          ? ""
          : this.target_item.limit_data;

      this.target_item.level =
        this.target_item.level == "" ? 0 : this.target_item.level;

      this.target_item.rarity =
        this.target_item.rarity == "-" ? "" : this.target_item.rarity;

      this.target_item.legend =
        this.target_item.legend == "-" ? "" : this.target_item.legend;

      this.target_item.race =
        this.target_item.race == "-" ? "" : this.target_item.race;

      this.target_item.monster_type1 =
        this.target_item.monster_type1 == "-"
          ? ""
          : this.target_item.monster_type1;

      this.target_item.monster_type2 =
        this.target_item.monster_type2 == "-"
          ? ""
          : this.target_item.monster_type2;

      this.target_item.support_type =
        this.target_item.support_type == "-"
          ? ""
          : this.target_item.support_type;

      var item = {};

      // ターゲット配列をphpに投げる
      this.card_data_cols.forEach(value => {
        var tmp_data = "";
        if (value == "card_text") {
          tmp_data = newlinesToBr(this.target_item[value]);
        } else if (value == "evaluation") {
          tmp_data = insertHtmlTag(this.target_item[value]);
        } else if (value == "id" || value == "level") {
          tmp_data = Number(this.target_item[value]);
        } else {
          tmp_data = this.target_item[value];
        }

        item[value] = tmp_data;
      });

      item.post_type = this.target_post_type;
      item.getdata = this.target_getdata_txt;
      console.log(item);

      var tmp_card_name = this.target_item.name;

      axios
        .post(process.env.VUE_APP_RD_CARD_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          // this.cardFilePut();
          this.getCardList();
          alert("《" + tmp_card_name + "》を" + msg + "しました！");
          this.showDialog = false;
        })
        .catch(error => {
          alert(
            "《" + tmp_card_name + "》の" + msg + "に失敗しました\n" + error
          );
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.loading = true;

      // 入手方法データのjsonアップロード
      axios
        .get(process.env.VUE_APP_RD_JSON_UPLOAD, {
          params: {
            json_type: "getmaster",
            id: Number(this.target_item.id)
          }
        })

        .then(response => {
          console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          alert("予期せぬエラーが発生しました。\n" + error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // カード削除
    //---------------------------
    delItem() {
      if (
        !window.confirm(
          "「" + this.target_name + "」を削除します。よろしいですか？"
        )
      ) {
        return;
      }

      var item = {
        id: Number(this.target_item.id),
        post_type: "delete"
      };
      //   console.log(item);

      axios
        .post(process.env.VUE_APP_RD_CARD_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("削除しました！");
          this.showDialog = false;
          this.getCardList();
        })
        .catch(error => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.showDialog2 = false;
    },

    //---------------------------
    // jsonファイル出力(更新されたカードのjson)
    //---------------------------
    cardFilePut() {
      // this.loading = true;

      var url = location.hostname;

      axios

        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_card_json_upload?url=" +
            url +
            "&id=" +
            this.target_item.id
        )

        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          // this.loading = false;
        });
    },

    //---------------------------
    // ダイアログ閉じ
    //---------------------------
    closeDialog() {
      this.showDialog = false;
    }
  },

  watch: {},

  beforeCreate: function() {}
};
</script>

<style>
.card_tab {
  height: 55vh;
}
/* .button_label_noimg,
.button_label_img {
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.button_label_noimg2,
.button_label_img2,
.article_button {
  font-size: 15px !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
} */
</style>
